<div id="loading-order" class="popup-comp data-loader" role="dialog">
  <div class="progress2 progress-moved">
    <div class="progress-bar2"></div>
  </div>
  <p class="reserve-text">
    {{ 'accountOverview.loader.loadingData' | cxTranslate }}
  </p>
</div>
